import type { OptionDealProductBuilderRow } from '@src/types/OTC/otcProductBuilderTypes';
import type { Column, StringSelectItem } from '@talos/kyoko';
import { OptionTypeEnum } from '@talos/kyoko';
import type { ColDef } from 'ag-grid-community';
import { buildSearchSelectColumn, type StringOrNullKeys } from './buildSearchSelectColumn';

interface BuildCurrencySelectorColumnParams<TRow extends object> {
  key: StringOrNullKeys<TRow>;
  headerName: string;
  currenciesToInclude: StringSelectItem[];
  description?: string;
  testIdPrefix?: string;
}

export function buildCurrencySelectorColumn<TRow extends object>({
  key,
  headerName,
  currenciesToInclude,
  description,
  testIdPrefix = 'currency-selector',
}: BuildCurrencySelectorColumnParams<TRow>): Column<ColDef<TRow>, TRow> {
  return buildSearchSelectColumn({
    key,
    headerName,
    items: currenciesToInclude,
    description,
    testIdPrefix,
    initialSortByLabel: true,
    showClear: true,
    defaultValue: 'Select',
    minWidth: 120,
    width: 140,
  });
}

const OPTION_TYPE_ITEMS: StringSelectItem[] = [
  { label: 'Call', value: OptionTypeEnum.Call },
  { label: 'Put', value: OptionTypeEnum.Put },
];

interface BuildOptionTypeSelectorColumnParams {
  headerName: string;
  description?: string;
  testIdPrefix?: string;
}

export function buildOptionTypeSelectorColumn({
  headerName,
  description,
  testIdPrefix = 'option-type-selector',
}: BuildOptionTypeSelectorColumnParams): Column<ColDef<OptionDealProductBuilderRow>, OptionDealProductBuilderRow> {
  return buildSearchSelectColumn<OptionDealProductBuilderRow>({
    key: 'optionType',
    headerName,
    items: OPTION_TYPE_ITEMS,
    description,
    testIdPrefix,
    initialSortByLabel: false,
    showClear: false,
    defaultValue: 'Call',
    minWidth: 80,
    width: 100,
    valueGetter: data => data?.optionType,
  });
}
